module.exports = __webpack_public_path__ + "assets/img/sig-logo-small.e44684b3.png";